/**
 * The toolbar buttons that carry no value of their own, so their only meaning is
 * "on or off".
 *
 * Shared by the editor, which resolves their toggles against the document, and
 * the toolbar, which lights them from the document — both instead of from
 * Quill's own `ql-active`. A control whose action and whose appearance come from
 * two different sources will eventually disagree, so they read the same list.
 */
export const INLINE_TOGGLE_FORMATS = ['bold', 'italic', 'strike'] as const

export type InlineToggleFormat = (typeof INLINE_TOGGLE_FORMATS)[number]
